import { useState, useEffect } from 'react';
import { 
    IonButton,
    IonIcon,
    IonText,
    IonAccordionGroup,
    IonAccordion,
    IonItem,
    IonList,
} from '@ionic/react';
import { 
  addCircleOutline,
  removeCircleOutline
} from "ionicons/icons";

import Fade from 'react-reveal/Fade';
import parse from 'html-react-parser';
import axios from 'axios'; //We can keep the axios call for this, as this is calling from Zendesk API



const FAQSection = () => {
  const [accordionIcon,setAccordionIcon] = useState([]);
  const [content, setContent] = useState({})

  useEffect(() => {
    async function getContent() {
        // Get Data from zendesk api
        const url = 'https://rydesupport.zendesk.com/api/v2/help_center/sections/360001663074/articles'
        let res = await axios.get(url)
        res = res.data.articles
        var parsed = []
        res.forEach(item => {
            parsed.push({
                question: item.title,
                answer: <div>{parse(item.body)}</div>
            })
        })
        // Sort parsed by position
        parsed = parsed.sort((a, b) => {
            return a.position - b.position
        })
        parsed = parsed.slice(0,6)
        setContent(parsed)
        setAccordionIcon(Object.entries(parsed).map(() => {return false}))
    }
    getContent()
}
, [])

  const updateToggle = (index) => {            
      const newArray = accordionIcon.map((item,i) => {
          if(i===index){
              return !item
          }
          return item
          }    
      );
      setAccordionIcon(newArray);
  }
  
  return (
      <div style={{
      height:'fit-content', 
      overflow:'hidden',
      paddingBlock: '50px'
      }}>
      <div style={{
          display:'flex',
          flexDirection:'column',
          justifyContent:'center',
          alignItems:'flex-start',
          padding:'20px',
          maxWidth: '1200px',
          width: '100%',
          margin: '0 auto',
      }}>
          <Fade up>
          <IonText 
          className="font-baloo font-semibold font-xl"
          style={{
              color: '#545252',
              alignSelf:'flex-start',
              marginBottom: '10px',
          }}>
          Frequently Asked Questions
          </IonText>
          </Fade>
          <IonAccordionGroup multiple={true} mode='ios' style={{width: '100%'}}>
          {content.length>0?
              content.map((item, index) => {
              return(
                  <Fade up key={index}>
                  <IonAccordion value={index.toString()} key={index} 
                  style={{
                    borderBottom: '1px solid rgba(199,181,181,0.52)'
                  }} 
                  toggleIcon={null}
                  >                       
                      <IonItem slot="header" onClick={()=>updateToggle(index)}>
                      {
                          accordionIcon[index] ?
                          <IonIcon slot="end" className="ion-accordion-toggle-icon" icon={removeCircleOutline} style={{
                          color: '#E93864',
                      }}></IonIcon>
                          :
                          <IonIcon slot="end" className="ion-accordion-toggle-icon" icon={addCircleOutline} style={{
                          color: '#E93864',
                      }}></IonIcon>
                      }
                      <IonText 
                      className="font-baloo font-m font-pink-1"
                      style={{
                          fontWeight: accordionIcon[index] ? 'bold' : 'normal',
                          paddingBlock: '10px'
                      }}>{item.question}</IonText>
                      </IonItem>
                      <IonList slot="content">
                          <div className="faq" style={{
                              paddingInline: '25px',
                              paddingLeft: '30px',
                              color:'#545252',
                              paddingBlock: '10px'
                          }}>
                              {item.answer}
                          </div>
                      </IonList>
                  </IonAccordion>
                  </Fade>
              )
          } 
          ): null}
          </IonAccordionGroup>
          
          <IonButton 
          onClick={()=>{window.open('https://help.rydesharing.com/hc/en-us/sections/360001663074-RydeSEND', '_blank')}}
          className="font-baloo font-m prelogin-button"
          style={{
              alignSelf: 'center',
              marginBlockStart: '20px',
          }}>
          See More FAQs
          </IonButton>
      </div>

      </div>
  )
}

export default FAQSection;